import { useState, useEffect, useReducer } from "react";
import openSocket from "socket.io-client";
import toastError from "../../errors/toastError";

import api from "../../services/api";

const reducer = (state, action) => {
	if (action.type === "LOAD_TELEGRAMS") {
		const telegrams = action.payload;

		return [...telegrams];
	}

	if (action.type === "UPDATE_TELEGRAMS") {
		const telegram = action.payload;
		const telegramIndex = state.findIndex(s => s.id === telegram.id);

		if (telegramIndex !== -1) {
			state[telegramIndex] = telegram;
			return [...state];
		} else {
			return [telegram, ...state];
		}
	}

	if (action.type === "UPDATE_SESSION") {
		const telegram = action.payload;
		const telegramIndex = state.findIndex(s => s.id === telegram.id);

		if (telegramIndex !== -1) {
			state[telegramIndex].phone = telegram.phone;
			state[telegramIndex].updatedAt = telegram.updatedAt;
			state[telegramIndex].connected = telegram.connected;
			state[telegramIndex].lastError = telegram.lastError;
			return [...state];
		} else {
			return [...state];
		}
	}

	if (action.type === "DELETE_TELEGRAMS") {
		const telegramId = action.payload;

		const telegramIndex = state.findIndex(s => s.id === telegramId);
		if (telegramIndex !== -1) {
			state.splice(telegramIndex, 1);
		}
		return [...state];
	}

	if (action.type === "RESET") {
		return [];
	}
};

const useTelegrams = () => {
	const [telegrams, dispatch] = useReducer(reducer, []);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(true);
		const fetchSession = async () => {
			try {
				const { data } = await api.get("/telegram/");
				dispatch({ type: "LOAD_TELEGRAMS", payload: data });
				setLoading(false);
			} catch (err) {
				setLoading(false);
				toastError(err);
			}
		};
		fetchSession();
	}, []);

	useEffect(() => {
		const socket = openSocket(window.env?.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_URL, { auth: { token: localStorage.getItem("socketToken") }});

		socket.on("telegram", data => {
			if (data.action === "update") {
				dispatch({ type: "UPDATE_TELEGRAMS", payload: data.telegram });
			}
		});

		socket.on("telegram", data => {
			if (data.action === "delete") {
				dispatch({ type: "DELETE_TELEGRAMS", payload: data.telegramId });
			}
		});

		socket.on("telegramSession", data => {
			if (data.action === "update") {
				dispatch({ type: "UPDATE_SESSION", payload: data.session });
			}
		});

		return () => {
			socket.disconnect();
		};
	}, []);

	return { telegrams, loading };
};

export default useTelegrams;
